import PropTypes from "prop-types";
import React from "react";
import { UserContextSelectors } from "../../redux/selectors/index.js";
import { useSelector } from "react-redux";
import { Brand } from "../../configurations/index.js";
import { SVGIcon2 } from "../../components/common/SVGIconV2.js";

const IslandResort = ({ handleClick }) => {
  const brandId = useSelector(UserContextSelectors.brandId);
  if (brandId !== Brand.Sport_MI) return <></>;
  else
    return (
      <div className="landResortIcon" onClick={handleClick}>
        <SVGIcon2 iconName="tribal-white" />
      </div>
    );
};

IslandResort.propTypes = {
  handleClick: PropTypes.func
};

export default IslandResort;
